<template>
  <div>
    <div class="outline_fancy_btn fb_btn" v-if="type === types.LOGIN_FB">
      <a class="fancy_btn" @click.prevent="connect" >
        <img src="/static/images/register/fb_logo.svg"> {{ getTranslations.visitor_facebook_login_login_with_fb }}
      </a>
    </div>
    <div v-else-if="type===types.CONNECT_FB_PROFILE" class="outline_fancy_btn fb_btn">
        <button class="fancy_btn" onlogin="connectTofb();" @click.prevent="login">
          <div class="home_row">
            <img src="/static/images/register/fb_logo.svg">
            <p>Connect your account with Facebook<br> to earn XXXX points!</p>
          </div>

        </button>
    </div>
    <div v-else>
      <div class="outline_fancy_btn fb_btn">
        <button onlogin="connectTofb();"
             class="fancy_btn"
             data-width=""
             data-size="large"
             data-button-type="continue_with"
             data-use-continue-as="false">
          <img src="/static/images/register/fb_logo.svg">
          Connect with Facebook
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import FacebookMixin from '@/common/mixins/facebookIntegration';

export default {
  name: 'facebook-login',
  props: ['errorsInFb', 'enteredUsername', 'type'],
  mixins: [FacebookMixin],
  data() {
    return {
      types: {
        REGISTRATION_FB: 'register',
        CONNECT_FB: 'connect',
        LOGIN_FB: 'login',
        CONNECT_FB_PROFILE: 'ConnectProf',
      },
      fb_error: false,
    };
  },
  created() {
    this.$emit('errorsUpdated', null);
  },
  mounted() {
    window.checkLoginState = this.connect;
    window.connectTofb = this.login;
    window.FB.XFBML.parse();
  },
  methods: {
    ...mapMutations('profile', [
      'setFirstTimeEntry',
    ]),
    ...mapMutations('common', [
      'storeUserAvatar',
      'updateUsername',
    ]),
    ...mapActions('common', [
      'sendFacebookImage',
      'updateDisplayAvatar',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'callForAuthorizationFB',
      'getUserLoginDetails',
      'changeUsername',
      'storeLoginInfo',
    ]),
    showError() {
      this.fb_error = true;
    },
    connect() {
      this.$emit('errorsUpdated', null);
      this.loginFbApi(this.userDetails.facebookId, this.successCallBack, this.invalidFbError);
    },
    successCallBack() {
      if (!this.token) this.token = localStorage.getItem('accessToken');
      const userData = {
        accessToken: this.token,
        msisdn: this.userDetails.msisdn !== '' ? this.userDetails.msisdn : null,
      };
      this.callForAuthorizationFB(userData).then(() => {
        if (this.getUserAuthorized) {
          if (this.type === this.types.LOGIN_FB) {
            this.getUserLoginDetails().then(() => {
              if (this.getUserAuthorized) {
                this.updateUserLanguage();
                this.$router.push('home');
              } else {
                this.$emit('errorsUpdated', 'visitor_login_server_error');
                this.logout(this.showError);
              }
            });
          } else { // connect
            this.getUserLoginDetails().then(() => {
              this.updateUserLanguage();
              this.getFbUserInfo((response3) => {
                localStorage.setItem('FacebookImage', response3.picture.data.url);
                this.sendFacebookImage().then(() => {
                  this.updateDisplayAvatar();
                  this.storeUserAvatar(response3.picture.data.url);
                  this.changeUsername({ username: response3.name }).then((response) => {
                    const res = response.data.responseEnum;
                    if (res === 'OPERATION_SUCCESS') {
                      this.updateUsername(response3.name);
                      this.storeLoginInfo({ token: response.data.data, username: response3.name, rememberMeParameter: true });
                    }
                  });
                });
              });
            });
          }
        } else {
          this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
          this.logout(this.showError);
        }
      });
    },
    invalidFbError() {
      console.log('User cancelled login or did not fully authorize.');
      this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
    },
    login() {
      this.$emit('errorsUpdated', null);
      this.checkLoginStatus(null, this.getFbUserInfo, this.callsAfterSuccessfulConnectionWithFB, this.invalidFbError);
    },
    callsAfterSuccessfulConnectionWithFB(userInfoResponse) {
      localStorage.setItem('facebookConnected', 'true');
      if (this.type === this.types.REGISTRATION_FB) {
        this.$emit('waitForCoreResponse', true);
        this.$axios.get('api/subscribeUser', {
          params: {
            msisdn: this.registrationInfoMsisdn,
            username: userInfoResponse.name,
            password: '',
            lang: this.getLocale,
            operator: this.multiOperatorInfo.operatorPicked || '',
            clickid: this.clickid,
            refUrl: this.refUrl,
            facebookId: userInfoResponse.id,
            facebookImage: userInfoResponse.picture.data.url,
            mail: userInfoResponse.email || '',
            fbReferral: this.fbReferral,
          },
        }).then((responseUser) => {
          this.$emit('waitForCoreResponse', false);
          if (responseUser.data.responseEnum === 'OPERATION_SUCCESS') {
            const userData = {
              accessToken: this.token,
            };
            this.callForAuthorizationFB(userData).then(() => {
              if (this.getUserAuthorized) {
                this.getUserLoginDetails().then(() => {
                  this.setFirstTimeEntry(true);
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              } else {
                this.logout(() => {
                  this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
                });
              }
            });
          } else {
            this.logout(() => {
              this.$emit('errorsUpdated', 'visitor_facebook_login_you_need_to');
            });
          }
        });
      } else { // if connect/login
        this.successCallBack();
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'userDetails',
      'connectionPoints',
      'fbReferral',
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/FacebookLogin.vue